import type { DatasetSummary } from '@/types/templates';

export function isPublicDatasetVisibility(visibility: unknown): visibility is 'public_preview' | 'public_utility' {
  return visibility === 'public_preview' || visibility === 'public_utility';
}

export function isUserDatasetVisibility(visibility: unknown): visibility is 'private' | 'team' {
  return visibility === 'private' || visibility === 'team';
}

export function isUserDatasetSummary(dataset: DatasetSummary): dataset is DatasetSummary & { visibility: 'private' | 'team' } {
  return isUserDatasetVisibility(dataset.visibility);
}

export function isPublicDatasetPayload(payload: unknown): payload is { visibility: 'public_preview' | 'public_utility' } {
  return (
    typeof payload === 'object' &&
    payload !== null &&
    isPublicDatasetVisibility((payload as { visibility?: unknown }).visibility)
  );
}

export function assertPublicDatasetListPayload(payload: unknown): asserts payload is DatasetSummary[] {
  if (!Array.isArray(payload) || !payload.every(isPublicDatasetPayload)) {
    throw new Error('Dataset public-only contract violation');
  }
}
